"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUtility = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classNameBuilders_1 = require("./classNameBuilders");
const setDisplayName_1 = (0, tslib_1.__importDefault)(require("./setDisplayName"));
const getDisplayname_1 = require("./getDisplayname");
function createUtility(name, applyUtility) {
    return () => (WrappedComponent) => {
        const UtilityWrapper = (props) => {
            const _a = props, { className } = _a, rest = (0, tslib_1.__rest)(_a, ["className"]);
            const utilityClassName = applyUtility(rest);
            return ((0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, rest, { className: (0, classNameBuilders_1.classnames)(className, utilityClassName) }), void 0));
        };
        return (0, setDisplayName_1.default)(`${name}(${(0, getDisplayname_1.getDisplayName)(WrappedComponent)})`)(UtilityWrapper);
    };
}
exports.createUtility = createUtility;
//# sourceMappingURL=createUtility.js.map